
export const moduleRoutes = {
    list: 'groups/',
    create: 'groups/',
    getMultiples: 'groups/get-multiples/',
    sync: 'groups/synchronize-tableau/',
};
